import { DynamicContentType, Shadow } from '../../types/content.types.js'
import { Rounded } from '../../types/content.types.js'
import { FileEntryBM } from '../../types/fileEntry.types.js'
import { LucideIconName } from '../../types/lucide.types.js'

export type ImageData = {
  file?: FileEntryBM
  imageText: string
  marginBottom?: string
  marginTop?: string
  rounded?: Rounded
  shadow?: Shadow
}

export const image: DynamicContentType<ImageData> = {
  name: 'image',
  viewName: 'Bild',
  featureKey: 'image',
  icon: LucideIconName.Image,
  default: true,
  uuid: '',
  data: {
    imageText: '',
    marginBottom: '1rem',
  },
}
